import * as React from 'react'
import type { ISalesTeamReassign } from '@user/store/salesTeam/typings'
import type { ENTITY_TYPES } from '@sales-center/common'
import { Formik } from 'formik'
import { ReAssignSalesTeamFormContent } from './ReAssignSalesTeamFormContent'

interface Props {
  onClose: () => void
  onUpdate: (s: number, o: string | null, r: boolean) => void
  salesTeam: ISalesTeamReassign
  entityType: ENTITY_TYPES
  entityId: number
  showInactiveUsers?: boolean
}

export function ReAssignSalesTeamForm(props: Props) {
  const { salesTeam, showInactiveUsers } = props
  const { salesTeamId, assigneeId } = salesTeam

  return (
    <Formik
      initialValues={{
        ownerId: assigneeId || 'unassigned',
        teamId: salesTeamId,
      }}
      onSubmit={() => {}}
    >
      <ReAssignSalesTeamFormContent
        onClose={props.onClose}
        onUpdate={props.onUpdate}
        salesTeam={props.salesTeam}
        entityType={props.entityType}
        entityId={props.entityId}
        showInactiveUsers={showInactiveUsers}
      />
    </Formik>
  )
}
